
const chat = {
    namespaced: true,
    state: () => ({
        client_id: null,
        isActive: false,
        visible: false,
    }),
    mutations: {
        setClient(state, id) {
            state.client_id = id;
        },
        setIsActive(state, status){
            state.isActive = status;
        },
        setVisible(state, status){
            state.visible = status;
        }


    },

}


export default chat;
